<template>
  <ui-selectbox
    id="signUpTimezone"
    :width="width"
    :maxHeight="320"
    :value="value"
    :items="items"
    :disabled="disabled"
    :placeholder="placeholder"
    :hideLabel="true"
    @click="$emit('click')"
    @input="onTimezoneChange"/>
</template>

<script>
import timezones from 'google-timezones-json'
import UiSelectbox from './UiSelectbox'
import { getOffset } from '@/libs/utils'

export default {
  name: 'TimezoneSelectbox',
  components: {
    UiSelectbox
  },
  props: [
    'value',
    'width',
    'disabled',
    'placeholder'
  ],
  computed: {
    items () {
      return Object.entries(timezones).filter(([key, value]) => {
        return value.substr(4, 6).split(':')[1] === '00'
      }).map(([key, value]) => {
        if (value.substr(4, 6).split(':')[1] === '00') {
          try {
            if (getOffset(key)) {
              return {
                value: key,
                text: `(${getOffset(key)}) ${key}`
              }
            }
          } catch (e) {
            // return false
          }
        }
      }).filter(item => {
        return !!item
      }).sort((a, b) => {
        return a.text.localeCompare(b.text)
      })
    }
  },
  methods: {
    onTimezoneChange (value) {
      this.$emit('change', {
        timezone: getOffset(value),
        timezoneName: value
      })
    }
  }
}
</script>

<style>

</style>
